import { Injectable, Type } from '@angular/core';
import { CartSalesStepComponent, CartTotalStepComponent, CheckoutStepComponent, ButtonsComponent } from 'gung-standard';
import {
  AssignJeevesDefaultsComponent,
  DeliveryLocationsJeevesComponent,
  JeevesCheckoutConfigService,
  OrderTermsJeevesComponent,
  SummarizeOrderJeevesComponent
} from 'gung-standard-jeeves';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs';
import { HeloCartSalesStepComponent } from '../components/checkout/finland/helo-cart-sales-step/helo-cart-sales-step.component';
import { HeloDeliveryLocationsComponent } from '../components/checkout/finland/helo-delivery-locations/helo-delivery-locations.component';
import { HeloOrderTermsJeevesComponent } from '../components/checkout/finland/helo-order-terms-jeeves/helo-order-terms-jeeves.component';
import { HeloSummarizeOrderJeevesComponent } from '../components/checkout/finland/helo-summarize-order-jeeves/helo-summarize-order-jeeves.component';
import { TyloAssignJeevesDefaultsComponent } from '../components/checkout/sweden/tylo-assign-jeeves-defaults/tylo-assign-jeeves-defaults.component';
import { TyloDeliveryLocationsJeevesComponent } from '../components/checkout/sweden/tylo-delivery-locations-jeeves/tylo-delivery-locations-jeeves.component';
import { TyloOrderTermsJeevesComponent } from '../components/checkout/sweden/tylo-order-terms-jeeves/tylo-order-terms-jeeves.component';
import { TyloOrderTermsWithCartListJeevesComponent } from '../components/checkout/sweden/tylo-order-terms-with-cart-list-jeeves/tylo-order-terms-with-cart-list-jeeves.component';
import { TyloSummarizeOrderJeevesComponent } from '../components/checkout/sweden/tylo-summarize-order-jeeves/tylo-summarize-order-jeeves.component';
import { TyloButtonsComponent } from '../components/checkout/tylo-buttons/tylo-buttons.component';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TyloCheckoutConfigService extends JeevesCheckoutConfigService {

  getMainProcessSteps(): Observable<Type<CheckoutStepComponent>[]> {
    return this.getMainProcessStepsTylo();
  }

  /**
   * Checkout steps for the Tylo project
   */

  protected getMainProcessStepsTylo(): Observable<Type<CheckoutStepComponent>[]> {
    return super.getMainProcessSteps().pipe(
      first(),
      map(d => {
        if (d.indexOf(DeliveryLocationsJeevesComponent) > -1) {
          d[d.indexOf(DeliveryLocationsJeevesComponent)] = TyloDeliveryLocationsJeevesComponent;
        }
        if (d.indexOf(OrderTermsJeevesComponent) > -1) {
          d[d.indexOf(OrderTermsJeevesComponent)] = TyloOrderTermsJeevesComponent;
        } else {
          d.splice(d.indexOf(TyloDeliveryLocationsJeevesComponent) + 1, 0, TyloOrderTermsJeevesComponent);
        }
        if (d.indexOf(SummarizeOrderJeevesComponent) > -1) {
          d[d.indexOf(SummarizeOrderJeevesComponent)] = TyloSummarizeOrderJeevesComponent;
        }
        // Tylo Order Terms with Cart List
        if (d.indexOf(CartSalesStepComponent) > -1) {
          d[d.indexOf(CartSalesStepComponent)] = TyloOrderTermsWithCartListJeevesComponent; // OrderTermsWithCartListJeevesComponent;
        }
        if (d.indexOf(CartTotalStepComponent) > -1) {
          d[d.indexOf(CartTotalStepComponent)] = TyloOrderTermsWithCartListJeevesComponent; // OrderTermsWithCartListJeevesComponent;
        }
        if (d.indexOf(TyloOrderTermsJeevesComponent) > -1) {
          d.splice(d.indexOf(TyloOrderTermsJeevesComponent), 1);
        }
        return d;
      })
    );
  }

  getInternalPreProcessSteps(): Observable<Type<CheckoutStepComponent>[]> {
    return super.getInternalPreProcessSteps().pipe(
      map(d => {
        d[d.indexOf(AssignJeevesDefaultsComponent)] = TyloAssignJeevesDefaultsComponent;
        return d;
      })
    );
  }

  getButtonsComponent(): Type<ButtonsComponent> {
    return TyloButtonsComponent;
  }
}
